/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "/dashboard",
    name: "UtaDashboard",
    view: "UtaDashboard",
  },
  {
    path: "/redeem-coupon",
    name: "RedeemCoupon",
    view: "RedeemCoupon",
    filePath: "CampCoupons",
  },
  {
    path: "/camp-coupons",
    name: "CampCoupons",
    view: "CampCoupons",
    filePath: "CampCoupons",
  },
  {
    path: "/login/:path?",
    name: "Login",
    view: "Login",
    role: ["admin"],
  },
  {
    path: "/payments",
    name: "Payments",
    view: "Payments",
    role: ["admin"],
  },
  {
    path: "/custom-payment",
    name: "CustomPayment",
    view: "CustomPayment",
    filePath: "Payment",
  },
  {
    path: "/schedules",
    name: "Schedules",
    view: "Schedules",
  },
  {
    path: "/schedule-details",
    name: "ScheduleDetails",
    view: "ScheduleDetails",
  },
  {
    path: "/accounts",
    name: "Accounts",
    view: "Accounts",
    role: ["admin"],
  },
  {
    path: "/accounts2",
    name: "Accounts2",
    view: "Accounts2",
    role: ["admin"],
  },
  {
    path: "/account-lookup",
    name: "AccountLookup",
    view: "AccountLookup",
    role: ["admin"],
  },
  {
    path: "/site-visits",
    name: "Site Visits",
    view: "SiteVisits",
    role: ["admin"],
  },
  {
    path: "/payment-pickups",
    name: "PaymentPickups",
    view: "PaymentPickups",
  },
  {
    path: "/publications",
    name: "Publications",
    view: "Publications",
  },
  {
    path: "/students",
    name: "Students",
    view: "Students",
  },
  {
    path: "/hs-new-students",
    name: "HsNewStudents",
    view: "HsNewStudents",
    filePath: "Students",
  },
  {
    path: "/hs-students-import",
    name: "HsStudentsImport",
    view: "HsStudentsImport",
    filePath: "Students",
  },
  {
    path: "/hs-matched-students",
    name: "HsMatchedStudents",
    view: "HsMatchedStudents",
    filePath: "Students",
  },
  {
    path: "/hs-students-view",
    name: "HsOfficeStudentsView",
    view: "HsOfficeStudentsView",
    filePath: "Students",
  },
  {
    path: "/student-voucher-status",
    name: "StudentVoucherStatus",
    view: "StudentVoucherStatus",
    filePath: "Students",
  },
  {
    path: "/chol-hamoed-program-reports",
    name: "CholHamoedProgramReports",
    view: "CholHamoedProgramReports",
  },
  {
    path: "/chol-hamoed-program-totals",
    name: "CholHamoedProgramTotals",
    view: "CholHamoedProgramTotals",
  },
  {
    path: "/chol-hamoed-program-students",
    name: "CholHamoedProgramStudents",
    view: "CholHamoedProgramStudents",
  },
  {
    path: "/apply-new-family",
    name: "ApplyNewFamily",
    view: "ApplyNewFamily",
    filePath: "Account",
  },
  {
    path: "/new-family-applications",
    name: "NewFamilyApplications",
    view: "NewFamilyApplications",
    filePath: "Account",
  },
  {
    path: "/family-application/:id",
    name: "FamilyApplication",
    view: "FamilyApplication",
    filePath: "Account",
  },
  {
    path: "/applicant-students",
    name: "ApplicantStudents",
    view: "ApplicantStudents",
    filePath: "Registration",
  },
  {
    path: "/75-enrollments",
    name: "75Enrollments",
    view: "75Enrollments",
    filePath: "Registration",
  },
  {
    path: "/butcher-rewards",
    name: "ButcherRewards",
    view: "ButcherRewards",
    filePath: "Payment",
  },
  {
    path: "/unprocessed-payments/:source?",
    name: "UnprocessedPayments",
    view: "UnprocessedPayments",
    filePath: "Payment",
  },
  {
    path: "/ach",
    name: "ReturnedACH",
    view: "ReturnedACH",
    filePath: "Payment",
  },
  {
    path: "/student-lookup",
    name: "StudentLookup",
    view: "StudentLookup",
    filePath: "Students",
  },
  {
    path: "/not-assined-students",
    name: "NotAssinedStudents",
    view: "NotAssinedStudents",
  },
  {
    path: "/student-attendance-cards",
    name: "StudentAttendanceCards",
    view: "StudentAttendanceCards",
    filePath: "Students",
  },
  {
    path: "/attendance-scans",
    name: "AttendanceScans",
    view: "AttendanceScans",
    filePath: "Students",
  },
  {
    path: "/attendance-daily-report",
    name: "AttendanceDailyReport",
    view: "AttendanceDailyReport",
    filePath: "Students",
  },
  {
    path: "/special-needs-students",
    name: "SpecialNeedsStudents",
    view: "SpecialNeedsStudents",
    filePath: "SpecialNeeds",
  },
  {
    path: "/student-view/:id",
    name: "StudentView",
    view: "StudentView",
    filePath: "Students",
  },
  {
    path: "/branches",
    name: "Branches",
    view: "Branches",
    filePath: "Students",
  },
  {
    path: "/classes",
    name: "Classes",
    view: "Classes",
    filePath: "Students",
  },
  {
    path: "/student-class-info",
    name: "StudentClassInfo",
    view: "StudentClassInfo",
    filePath: "Students",
  },
  {
    path: "/kita-alef-messages",
    name: "KitaAlefMessages",
    view: "KitaAlefMessages",
    filePath: "Students",
  },
  {
    path: "/special-needs-student-apply/:id",
    name: "SpecialNeedsStudentApply",
    view: "SpecialNeedsStudentApply",
    filePath: "SpecialNeeds",
  },
  {
    path: "/special-needs-student-view/:id",
    name: "SpecialNeedsStudentView",
    view: "SpecialNeedsStudentView",
    filePath: "SpecialNeeds",
  },
  {
    path: "/student-calls",
    name: "StudentCalls",
    view: "StudentCalls",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/transportation/buses",
    name: "Buses",
    view: "Buses",
    filePath: "Transportation",
  },
  {
    path: "/transportation/drivers",
    name: "Drivers",
    view: "Drivers",
    filePath: "Transportation",
  },
  {
    path: "/transportation/routes",
    name: "Routes",
    view: "Routes",
    filePath: "Transportation",
  },
  {
    path: "/transportation/routes-report",
    name: "RoutesReport",
    view: "RoutesReport",
    filePath: "Transportation",
  },
  {
    path: "/transportation/driver-absent",
    name: "DriverAbsent",
    view: "DriverAbsent",
    filePath: "Transportation",
  },
  {
    path: "/transportation/deductions",
    name: "Deductions",
    view: "Deductions",
    filePath: "Transportation",
  },
  {
    path: "/transportation/deduction-report",
    name: "DeductionReport",
    view: "DeductionReport",
    filePath: "Transportation",
  },
  {
    path: "/transportation/routes-calander",
    name: "RoutesCalander",
    view: "RoutesCalander",
    filePath: "Transportation",
  },
  {
    path: "/transportation/bus-changes",
    name: "BusChanges",
    view: "BusChanges",
    filePath: "Transportation",
  },
  {
    path: "/transportation/dispatching",
    name: "BusDispatching",
    view: "BusDispatching",
    filePath: "Transportation",
  },
  {
    path: "/transportation/bus-change-requests",
    name: "BusChangeRequests",
    view: "BusChangeRequests",
    filePath: "Transportation",
  },
  {
    path: "/transportation/geo-student-stops",
    name: "GeoStudentStops",
    view: "GeoStudentStops",
    filePath: "Transportation",
  },
  {
    path: "/transportation/route-designs",
    name: "RouteDesigns",
    view: "RouteDesigns",
    filePath: "Transportation",
  },
  {
    path: "/transportation/bus-assignments",
    name: "BusAssignments",
    view: "BusAssignments",
    filePath: "Transportation",
  },
  {
    path: "/transportation/student-flags",
    name: "StudentFlags",
    view: "StudentFlags",
    filePath: "Transportation",
  },
  {
    path: "/transportation/route-design-map/:id",
    name: "RouteDesignMap",
    view: "RouteDesignMap",
    filePath: "Transportation",
  },
  {
    path: "/geo/geo-students",
    name: "GeoStudents",
    view: "GeoStudents",
    filePath: "Geo",
  },
  {
    path: "/geo/geo-student-status",
    name: "GeoStudentStatus",
    view: "GeoStudentStatus",
    filePath: "Geo",
  },
  {
    path: "/geo/geo-map-view",
    name: "GeoMapView",
    view: "GeoMapView",
    filePath: "Geo",
  },
  {
    path: "/school-phones",
    name: "SchoolPhones",
    view: "SchoolPhones",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/teacher-settings",
    name: "TeacherSettings",
    view: "TeacherSettings",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/broadcast-contacts",
    name: "BroadcastContacts",
    view: "BroadcastContacts",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/kesher-employees",
    name: "KesherEmployees",
    view: "KesherEmployees",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/tip-payments",
    name: "TipPayments",
    view: "TipPayments",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/tip-transactions",
    name: "TipTransactions",
    view: "TipTransactions",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/teacher-relations",
    name: "TeacherRelations",
    view: "TeacherRelations",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/teacher-view/:id",
    name: "TeacherView",
    view: "TeacherView",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/appointments",
    name: "Appointments",
    view: "Appointments",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/class-summary",
    name: "ClassSummary",
    view: "ClassSummary",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/new-child-appointments",
    name: "NewChildAppointments",
    view: "NewChildAppointments",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/tips",
    name: "Tips",
    view: "Tips",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/school/menahal-new-broadcast",
    name: "MenahalNewBroadcast",
    view: "MenahalNewBroadcast",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/school/menahal-broadcasts",
    name: "MenahalBroadcasts",
    view: "MenahalBroadcasts",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/school/school-split-students",
    name: "SchoolSplitStudents",
    view: "SchoolSplitStudents",
    filePath: "SchoolCallingSystem",
    claimOnly: true,
  },
  {
    path: "/students/buildings",
    name: "Buildings",
    view: "Buildings",
    filePath: "Students",
  },
  {
    path: "/kollel-applications",
    name: "KollelApplications",
    view: "KollelApplications",
    filePath: "Registration",
  },
  {
    path: "/kollel-application/:accountid/:id?",
    name: "KollelApplication",
    view: "KollelApplication",
    filePath: "Registration",
  },
  {
    path: "/tuition-contract-scholarship-applications",
    name: "TuitionContractScholarshipApplications",
    view: "TuitionContractScholarshipApplications",
    filePath: "Registration",
  },
  {
    path: "/vm-forms",
    name: "VmForms",
    view: "VmForms",
    filePath: "Registration",
  },
  {
    path: "/vm-form-logs",
    name: "VmFormLogs",
    view: "VmFormLogs",
    filePath: "Registration",
  },
  {
    path: "/vm-form/:accountid/:id?",
    name: "VmForm",
    view: "VmForm",
    filePath: "Registration",
  },
  {
    path: "/vm-account-status",
    name: "VmAccountStatus",
    view: "VmAccountStatus",
    filePath: "Registration",
  },
  {
    path: "/kollel-application-logs",
    name: "KollelApplicationLogs",
    view: "KollelApplicationLogs",
    filePath: "Registration",
  },
  {
    path: "/kollel-applications",
    name: "KollelApplications",
    view: "KollelApplications",
    filePath: "Registration",
  },
  {
    path: "/registration/register-hs",
    name: "RegisterHS",
    view: "RegisterHS",
    filePath: "Registration",
  },
  {
    path: "/ivr-calls",
    name: "IVRCalls",
    view: "IVRCalls",
  },
  {
    path: "/documents",
    name: "Documents",
    view: "Documents",
    role: ["admin"],
  },
  {
    path: "/contactUs",
    name: "ContactUs",
    view: "ContactUs",
  },
  {
    path: "/settings/settings",
    name: "Settings",
    view: "Settings",
    filePath: "Settings",
    role: ["admin"],
  },
  {
    path: "/settings/roles",
    name: "Roles",
    view: "Roles",
    filePath: "Settings",
    role: ["admin"],
  },
  {
    path: "/settings/users",
    name: "Users",
    view: "Users",
    filePath: "Settings",
    role: ["admin"],
  },
  {
    path: "/settings/portal-errors",
    name: "PortalErrors",
    view: "PortalErrors",
    filePath: "Settings",
    role: ["admin"],
  },
  {
    path: "/settings/send-notifications",
    name: "SendNotifications",
    view: "SendNotifications",
    filePath: "Settings",
    role: ["admin"],
  },
  {
    path: "/settings/add-user",
    name: "AddUser",
    view: "AddUser",
    filePath: "Settings",
    role: ["admin"],
  },
  {
    path: "/helpdesk/requests",
    name: "HelpDeskRequests",
    view: "HelpDeskRequests",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/request/:id",
    name: "HelpDeskRequestView",
    view: "HelpDeskRequestView",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/technician/requests",
    name: "HelpDeskTechnicianRequests",
    view: "HelpDeskTechnicianRequests",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/technician/request/:id",
    name: "HelpDeskTechnicianRequestView",
    view: "HelpDeskTechnicianRequestView",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/manageengine-users",
    name: "ManageengineUsers",
    view: "ManageengineUsers",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/manageengine-technicians",
    name: "ManageengineTechnicians",
    view: "ManageengineTechnicians",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/manageengine-sites",
    name: "ManageengineSites",
    view: "ManageengineSites",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/manageengine-categories",
    name: "ManageengineCategories",
    view: "ManageengineCategories",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/manageengine-priorities",
    name: "ManageenginePriorities",
    view: "ManageenginePriorities",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/manageengine-acknowledges",
    name: "ManageengineAcknowledges",
    view: "ManageengineAcknowledges",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/manageengine-overview",
    name: "ManageEngineOverview",
    view: "HelpDeskOverview",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/dashboard-summary",
    name: "HelpDeskDashboardSummary",
    view: "DashboardSummary",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/helpdesk/information",
    name: "HelpDeskInformation",
    view: "Information",
    filePath: "HelpDeskTickets",
  },
  {
    path: "/navigation-settings",
    name: "NavigationSettings",
    view: "NavigationSettings",
    filePath: "Settings",
  },
  {
    path: "/credit-card-charges",
    name: "CreditCardCharges",
    view: "CreditCardCharges",
    filePath: "Other",
  },
  {
    path: "/credit-card-charge-view/:id",
    name: "CreditCardChargeView",
    view: "CreditCardChargeView",
    filePath: "Other",
  },
  {
    path: "/shared-files",
    name: "SharedFiles",
    view: "SharedFiles",
    filePath: "Other",
  },
  {
    path: "/files-shared-with-user",
    name: "FilesSharedWithUser",
    view: "FilesSharedWithUser",
    filePath: "Other",
  },
  {
    path: "/food-assistance-applications",
    name: "FoodAssistanceApplications",
    view: "FoodAssistanceApplications",
    filePath: "Other",
  },
  {
    path: "/employer-childcare-benefit-requests",
    name: "EmployerChildcareBenefitRequests",
    view: "EmployerChildcareBenefitRequests",
    filePath: "Other",
  },
  {
    path: "/businesses",
    name: "Businesses",
    view: "Businesses",
    filePath: "Other",
  },
  {
    path: "/business-view/:id/:term?",
    name: "BusinessView",
    view: "BusinessView",
    filePath: "Other",
  },
  {
    path: "/conference-room-scheduler",
    name: "ConferenceRoomScheduler",
    view: "ConferenceRoomScheduler",
    filePath: "ConferenceRoom",
  },
  {
    path: "/conference-room-users",
    name: "ConferenceRoomUsers",
    view: "ConferenceRoomUsers",
    filePath: "ConferenceRoom",
  },
  {
    path: "/conference-room-kiosk",
    name: "ConferenceRoomKiosk",
    view: "ConferenceRoomKiosk",
    filePath: "ConferenceRoom",
  },
  {
    path: "/account-view/:id",
    name: "Account View",
    view: "AccountView",
    role: ["admin"],
  },
  {
    path: "/phone",
    name: "PhoneNumbers",
    view: "PhoneNumbers",
    role: ["admin"],
  },
  {
    path: "/sms-old",
    name: "SMSOld",
    view: "SMSOld",
    role: ["admin"],
  },
  {
    path: "/sms",
    name: "SMS",
    view: "SMS",
  },
  {
    path: "/sms/send-message",
    name: "SendMessage",
    view: "SendMessage",
    filePath: "Broadcast",
  },
  {
    path: "/broadcast/new-broadcast/:id?",
    name: "NewBroadcast",
    view: "NewBroadcast",
    filePath: "Broadcast",
  },
  {
    path: "/broadcast/calls/:id",
    name: "BroadcastCalls",
    view: "BroadcastCalls",
    filePath: "Broadcast",
  },
  {
    path: "/broadcast/messages/:id",
    name: "BroadcastMessages",
    view: "BroadcastMessages",
    filePath: "Broadcast",
  },
  // {
  //     path: "/call/broadcast-call",
  //     name: "BroacastCall",
  //     view: "BroacastCall",
  //     filePath: "Broadcast",
  // },
  {
    path: "/calls",
    name: "Calls",
    view: "Calls",
    filePath: "Broadcast",
  },
  {
    path: "/broadcasts",
    name: "Broadcasts",
    view: "Broadcasts",
    filePath: "Broadcast",
  },
  {
    path: "/broadcast-dashboard",
    name: "BroadcastDashboard",
    view: "BroadcastDashboard",
    filePath: "Broadcast",
  },
  {
    path: "/surveys",
    name: "Surveys",
    view: "Surveys",
    filePath: "Broadcast",
  },
  {
    path: "/menahal-audio-library",
    name: "MenahalAudioLibrary",
    view: "MenahalAudioLibrary",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/my-kesher-report",
    name: "MyKesherReport",
    view: "MyKesherReport",
    filePath: "SchoolCallingSystem",
  },
  {
    path: "/audio-library",
    name: "AudioLibrary",
    view: "AudioLibrary",
    filePath: "Broadcast",
  },
  {
    path: "/new-immunization-broadcast",
    name: "NewImmunizationBroadcast",
    view: "NewImmunizationBroadcast",
    filePath: "Broadcast",
  },
  {
    path: "/new-meat-broadcast",
    name: "NewMeatBroadcast",
    view: "NewMeatBroadcast",
    filePath: "Broadcast",
  },
  {
    path: "/broadcast-notifications",
    name: "BroadcastNotifications",
    view: "BroadcastNotifications",
    filePath: "Broadcast",
  },
  {
    path: "/broadcast-emails",
    name: "BroadcastEmails",
    view: "BroadcastEmails",
    filePath: "Broadcast",
  },
  {
    path: "/communication-log",
    name: "CommunicationLog",
    view: "CommunicationLog",
    filePath: "Broadcast",
  },
  {
    path: "/voting-master-list",
    name: "VotingMasterList",
    view: "VotingMasterList",
    filePath: "Votes",
  },
  {
    path: "/doe",
    name: "DOE",
    view: "DOE",
    filePath: "Votes",
  },
  {
    path: "/voting-reg-notes",
    name: "VotingNotes",
    view: "VotingNotes",
    filePath: "Votes",
  },
  {
    path: "/voting-reg-auto-match",
    name: "VotingRegistrationAutoMatch",
    view: "VotingRegistrationAutoMatch",
    filePath: "Votes",
  },
  {
    path: "/voting-reg-auto-match-details/:id",
    name: "VotingRegistrationAutoMatchDetails",
    view: "VotingRegistrationAutoMatchDetails",
    filePath: "Votes",
  },
  {
    path: "/yg-students",
    name: "YgStudents",
    view: "YgStudents",
    filePath: "Votes",
  },
  {
    path: "/voting-reg-forms",
    name: "VotingRegistrationForms",
    view: "VotingRegistrationForms",
    filePath: "Votes",
  },
  {
    path: "/accounts-voting-registration-status",
    name: "AccountsVotingRegistrationStatus",
    view: "AccountsVotingRegistrationStatus",
    filePath: "Votes",
  },
  {
    path: "/voting-registration-submissions",
    name: "VotingRegistrationSubmissions",
    view: "VotingRegistrationSubmissions",
    filePath: "Votes",
  },
  {
    path: "/online-voting-registration-forms",
    name: "OnlineVotingRegistrationForms",
    view: "OnlineVotingRegistrationForms",
    filePath: "Votes",
  },
  {
    path: "/file-downloads",
    name: "FileDownloads",
    view: "FileDownloads",
  },
  {
    path: "/phone-detail/:id?",
    view: "PhoneDetail",
    name: "Phone Detail",
    role: ["admin"],
  },
  {
    path: "/lapidus/register",
    view: "LapidusRegister",
    name: "LapidusRegister",
    filePath: "LapidusDayCamp",
    role: ["admin"],
  },
  {
    path: "/lapidus/accounts",
    view: "LapidusAccounts",
    name: "LapidusAccounts",
    role: ["admin"],
  },
  {
    path: "/lapidus/billing",
    view: "LapidusBilling",
    name: "LapidusBilling",
    role: ["admin"],
  },
  {
    path: "/lapidus/daycamp-accounts",
    view: "LapidusDayCampAccounts",
    name: "LapidusDayCampAccounts",
  },
  {
    path: "/lapidus/account/:id/:reg_id?",
    name: "LapidusAccountView",
    view: "LapidusAccountView",
    role: ["admin"],
  },
  {
    path: "/lapidus/billing/:id/:reg_id?",
    name: "LapidusBillingView",
    view: "LapidusBillingView",
    filePath: "LapidusDayCamp",
    role: ["admin"],
  },
  {
    path: "/lapidus/classes",
    view: "LapidusClasses",
    name: "LapidusClasses",
    role: ["admin"],
  },
  {
    path: "/lapidus/students",
    view: "LapidusStudents",
    name: "LapidusStudents",
    role: ["admin"],
  },
  {
    path: "/lapidus/payments",
    view: "LapidusPayments",
    name: "LapidusPayments",
    role: ["admin"],
  },
  {
    path: "/lapidus/documents",
    view: "LapidusDocuments",
    name: "LapidusDocuments",
    filePath: "LapidusDayCamp",
  },
  // {
  //     path: "/lapidus/unprocessed-payments",
  //     view: "LapidusUnprocessedPayments",
  //     name: "LapidusUnprocessedPayments",
  //     filePath: "LapidusDayCamp",
  // },
  {
    path: "/lapidus/addclass/:id?",
    view: "LapidusAddClass",
    name: "LapidusAddClass",
    role: ["admin"],
  },
  {
    path: "/lapidus/class-summary",
    view: "LapidusClassSummary",
    name: "LapidusClassSummary",
    role: ["admin"],
  },
  {
    path: "/lapidus/apply",
    view: "Apply",
    name: "LapidusApply",
    role: ["admin"],
  },
  {
    path: "/lapidus/residents",
    name: "LapidusResidents",
    view: "LapidusResidents",
    filePath: "LapidusDayCamp",
  },
  {
    path: "/lapidus/residents-setup",
    name: "LapidusResidentsSetup",
    view: "LapidusResidentsSetup",
    filePath: "LapidusDayCamp",
  },
  {
    path: "/ykc/apply",
    view: "YKApply",
    name: "YKApply",
    filePath: "YKC",
  },
  {
    path: "/ykc/accounts",
    view: "YKAccounts",
    name: "YKAccounts",
    filePath: "YKC",
  },
  {
    path: "/ykc/accounts-extended",
    view: "YKAccountsExtended",
    name: "YKAccountsExtended",
    filePath: "YKC",
  },
  {
    path: "/ykc/students",
    view: "YKStudents",
    name: "YKStudents",
    filePath: "YKC",
  },
  {
    path: "/ykc/payments",
    view: "YKPayments",
    name: "YKPayments",
    filePath: "YKC",
  },
  {
    path: "/ykc/payment-details",
    view: "YKPaymentDetails",
    name: "YKPaymentDetails",
    filePath: "YKC",
  },
  {
    path: "/ykc/documents",
    view: "YKDocuments",
    name: "YKDocuments",
    filePath: "YKC",
  },
  // {
  //     path: "/ykc/unprocessed-payments",
  //     view: "YKCUnprocessedPayments",
  //     name: "YKCUnprocessedPayments",
  //     filePath: "YKC",
  // },
  {
    path: "/ykc/account/:id/:reg_id?",
    view: "YKCAccountView",
    name: "YKCAccountView",
    filePath: "YKC",
  },
  {
    path: "/ykc/recent-pages",
    view: "YKCRecentPages",
    name: "YKCRecentPages",
    filePath: "YKC",
  },
  {
    path: "/ykc/notes",
    view: "YKCNotes",
    name: "YKCNotes",
    filePath: "YKC",
  },
  {
    path: "/ykc/billing-report",
    view: "YKBilling",
    name: "YKBilling",
    filePath: "YKC",
  },
  {
    path: "/ykc/billing-summary",
    view: "YKSummary",
    name: "YKSummary",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-families",
    view: "YkCampFamilies",
    name: "YkCampFamilies",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-distribution-requests",
    view: "YkCampDistributionRequests",
    name: "YkCampDistributionRequests",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-family-view/:id",
    view: "YkCampFamilyView",
    name: "YkCampFamilyView",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-menu-summary",
    view: "YkCampDistributionMenuSummary",
    name: "YkCampDistributionMenuSummary",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-menu-summary-family-report",
    view: "YkCampDistributionMenuSummaryByFamily",
    name: "YkCampDistributionMenuSummaryByFamily",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-distribution-logs",
    view: "YkCampDistributionLogs",
    name: "YkCampDistributionLogs",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-distribution-ivr-calls",
    view: "YkCampDistributionIVRCalls",
    name: "YkCampDistributionIVRCalls",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-distributions",
    view: "CampDistributions",
    name: "CampDistributions",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-menu-items",
    view: "YkCampMenuItems",
    name: "YkCampMenuItems",
    filePath: "YKC",
  },
  {
    path: "/ykc/camp-distribution-default-totals",
    view: "YkCampDistributionDefaultTotals",
    name: "YkCampDistributionDefaultTotals",
    filePath: "YKC",
  },
  {
    path: "/yk-students",
    view: "YKStudents",
    name: "YKStudents",
    filePath: "YK",
  },
  {
    path: "/yk-recordings",
    view: "YKRecordings",
    name: "YKRecordings",
    filePath: "YK",
  },
  {
    path: "/dinner/ivr-calls",
    name: "DinnerIVRCalls",
    view: "DinnerIVRCalls",
    filePath: "Dinner",
  },
  {
    path: "/dinner/site-visits",
    name: "DinnerSiteVisits",
    view: "DinnerSiteVisits",
    filePath: "Dinner",
  },
  {
    path: "/dinner/payments",
    name: "DonationPayments",
    view: "DonationPayments",
    filePath: "Dinner",
  },
  {
    path: "/dinner/donors",
    name: "Donors",
    view: "Donors",
    filePath: "Dinner",
  },
  {
    path: "/dinner/kapures",
    name: "Kapures",
    view: "Kapures",
    filePath: "Dinner",
  },
  {
    path: "/dinner/kapures-totals",
    name: "KapuresTotals",
    view: "KapuresTotals",
    filePath: "Dinner",
  },
  {
    path: "/dinner/year-book-ad-payments",
    name: "YearBookAdPayments",
    view: "YearBookAdPayments",
    filePath: "Dinner",
  },
  {
    path: "/dinner/dinner-account-view/:id",
    name: "DinnerAccountView",
    view: "DinnerAccountView",
    filePath: "Dinner",
  },
  {
    path: "/dinner/news",
    name: "DinnerNews",
    view: "DinnerNews",
    filePath: "Dinner",
  },
  {
    path: "/alumini",
    name: "Alumini",
    view: "Alumini",
    filePath: "Dinner",
  },
  {
    path: "/dinner/alumini-student/:id",
    name: "AluminiStudentView",
    view: "AluminiStudentView",
    filePath: "Dinner",
  },
  {
    path: "/purim/students",
    name: "PurimStudents",
    view: "PurimStudents",
    filePath: "Purim",
  },
  {
    path: "/purim/transactions",
    name: "PurimPayments",
    view: "PurimPayments",
    filePath: "Purim",
  },
  {
    path: "/purim/gifts",
    name: "PurimGifts",
    view: "PurimGifts",
    filePath: "Purim",
  },
  {
    path: "/purim/totals",
    name: "PurimTotals",
    view: "PurimTotals",
    filePath: "Purim",
  },
  {
    path: "/purim/tracking-details",
    name: "PurimTrackingDetails",
    view: "PurimTrackingDetails",
    filePath: "Purim",
  },
  {
    path: "/purim/settings",
    name: "PurimSettings",
    view: "PurimSettings",
    filePath: "Purim",
  },
  {
    path: "/purim/student/:id",
    name: "PurimStudentView",
    view: "PurimStudentView",
    filePath: "Purim",
  },
  {
    path: "/camp-petition/submissions",
    name: "PetitionSubmissions",
    view: "PetitionSubmissions",
  },
  {
    path: "/camp-petition/sms",
    name: "PetitionSmsDetails",
    view: "PetitionSmsDetails",
  },
  {
    path: "/girls-camp/accounts",
    view: "GirlsCampAccounts",
    name: "GirlsCampAccounts",
    filePath: "GirlsCamp",
  },
  {
    path: "/girls-camp/covid-labels",
    view: "GirlsCampCovidLabels",
    name: "GirlsCampCovidLabels",
    filePath: "GirlsCamp",
  },
  {
    path: "/girls-camp/account/:id",
    name: "GirlsCampAccountView",
    view: "GirlsCampAccountView",
    filePath: "GirlsCamp",
  },
  {
    path: "/girls-camp/classes",
    view: "GirlsCampClasses",
    name: "GirlsCampClasses",
    filePath: "GirlsCamp",
  },
  {
    path: "/girls-camp/students",
    view: "GirlsCampStudents",
    name: "GirlsCampStudents",
    filePath: "GirlsCamp",
  },
  {
    path: "/girls-camp/payments",
    view: "GirlsCampPayments",
    name: "GirlsCampPayments",
    filePath: "GirlsCamp",
  },
  {
    path: "/girls-camp/addclass/:id?",
    view: "GirlsCampAddClass",
    name: "GirlsCampAddClass",
    filePath: "GirlsCamp",
  },
  {
    path: "/girls-camp/class-summary",
    view: "GirlsCampClassSummary",
    name: "GirlsCampClassSummary",
    filePath: "GirlsCamp",
  },
  {
    path: "/girls-camp/apply",
    view: "GirlsCampApply",
    name: "GirlsCampApply",
    filePath: "GirlsCamp",
  },
  {
    path: "/day-camp/status-lookup",
    view: "StudentStatusLookup",
    name: "StudentStatusLookup",
    filePath: "DayCamp",
  },
  {
    path: "/covid-test/test-entry",
    view: "CovidTestEntry",
    name: "CovidTestEntry",
    filePath: "CovidTests",
  },
  {
    path: "/covid-screening/covid-screening-sms-sessions",
    view: "CovidScreeningSmsSessions",
    name: "CovidScreeningSmsSessions",
    filePath: "CovidScreening",
  },
  {
    path: "/covid-screening/covid-screening-status",
    view: "CovidScreeningStatus",
    name: "CovidScreeningStatus",
    filePath: "CovidScreening",
  },
  {
    path: "/covid-screening/covid-screening-students",
    view: "CovidScreeningStudents",
    name: "CovidScreeningStudents",
    filePath: "CovidScreening",
  },
  {
    path: "/covid-screening/covid-screening-logs",
    view: "CovidScreeningLogs",
    name: "CovidScreeningLogs",
    filePath: "CovidScreening",
  },
  {
    path: "/communications/inbox",
    view: "CommunicationsInbox",
    name: "CommunicationsInbox",
    filePath: "Communications",
  },
  {
    path: "/communications/sms-pending-messages",
    view: "SmsPendingMessages",
    name: "SmsPendingMessages",
    filePath: "Communications",
  },
  {
    path: "/communications/pending-callback-requests",
    view: "PendingCallbackRequests",
    name: "PendingCallbackRequests",
    filePath: "Communications",
  },
  {
    path: "/communications/callback-requests",
    view: "CallbackRequests",
    name: "CallbackRequests",
    filePath: "Communications",
  },
  {
    path: "/communications/account-messages",
    view: "AccountMessages",
    name: "AccountMessages",
    filePath: "Communications",
  },
  {
    path: "/communications/callback-summary",
    view: "CallbackRequestSummary",
    name: "CallbackRequestSummary",
    filePath: "Communications",
  },
  {
    path: "/communications/tuition-discount-requests",
    view: "TuitionDiscountRequests",
    name: "TuitionDiscountRequests",
    filePath: "Communications",
  },
  {
    path: "/communications/emails",
    view: "Emails",
    name: "Emails",
    filePath: "Communications",
  },
  {
    path: "/communications/faxes",
    view: "Faxes",
    name: "Faxes",
    filePath: "Communications",
  },
  {
    path: "/communications/voicemails",
    view: "Voicemails",
    name: "Voicemails",
    filePath: "Communications",
  },
  {
    path: "/communications/calls",
    view: "CustomerCalls",
    name: "CustomerCalls",
    filePath: "Communications",
  },
  {
    path: "/communications/queue-report",
    view: "QueueReport",
    name: "QueueReport",
    filePath: "Communications",
  },
  {
    path: "/communications/feedback",
    view: "Feedback",
    name: "Feedback",
    filePath: "Communications",
  },
  {
    path: "/communications/kesher-feedback-messages",
    view: "KesherFeedbackMessages",
    name: "KesherFeedbackMessages",
    filePath: "Communications",
  },
  {
    path: "/document-splitter/:source/:sourceId",
    view: "DocumentSplitter",
    name: "DocumentSplitter",
    filePath: "DocumentSplitter",
  },
  {
    path: "/food-distribution/families",
    view: "FoodDistributionFamilies",
    name: "FoodDistributionFamilies",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/distributions",
    view: "WeeklyDistributions",
    name: "WeeklyDistributions",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/routes",
    view: "FoodDistributionRoutes",
    name: "FoodDistributionRoutes",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/route-details",
    view: "FoodDistributionRouteDetails",
    name: "FoodDistributionRouteDetails",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/all-boxes",
    view: "FoodDistributionAllBoxes",
    name: "FoodDistributionAllBoxes",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/scans",
    view: "FoodDistributionScans",
    name: "FoodDistributionScans",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/feedback",
    view: "FoodDistributionFeedback",
    name: "FoodDistributionFeedback",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/add-family/:id",
    view: "FoodDistributionAddFamily",
    name: "FoodDistributionAddFamily",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/family-view/:id",
    view: "FoodDistributionFamilyView",
    name: "FoodDistributionFamilyView",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/siblings",
    view: "FoodDistributionSiblings",
    name: "FoodDistributionSiblings",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/changes",
    view: "FoodDistributionEnrollmentChanges",
    name: "FoodDistributionEnrollmentChanges",
    filePath: "FoodDistribution",
  },
  {
    path: "/food-distribution/logs",
    view: "FoodDistributionLogs",
    name: "FoodDistributionLogs",
    filePath: "FoodDistribution",
  },
  {
    path: "/camp-calling-card/call-stats",
    view: "CampCallStats",
    name: "CampCallStats",
    filePath: "CampCallingSystem",
  },
  {
    path: "/camp-calling-card/calls",
    view: "CampCalls",
    name: "CampCalls",
    filePath: "CampCallingSystem",
  },
  {
    path: "/camp-calling-card/students",
    view: "CampStudents",
    name: "CampStudents",
    filePath: "CampCallingSystem",
  },
  {
    path: "/camp-calling-card/student/:id",
    view: "CampStudentView",
    name: "CampStudentView",
    filePath: "CampCallingSystem",
  },
  {
    path: "/camp-calling-card/camp-settings",
    view: "CampSettings",
    name: "CampSettings",
    filePath: "CampCallingSystem",
  },
  {
    path: "/camp-calling-card/signalwire-calls",
    view: "SignalwireCallLogs",
    name: "SignalwireCallLogs",
    filePath: "CampCallingSystem",
  },
  {
    path: "/genvite/persons",
    view: "GenvitePersons",
    name: "GenvitePersons",
    filePath: "Genvite",
  },
  {
    path: "/genvite/conflicts",
    view: "GenviteConflicts",
    name: "GenviteConflicts",
    filePath: "Genvite",
  },
  {
    path: "/genvite/conflict-details",
    view: "GenviteConflictDetails",
    name: "GenviteConflictDetails",
    filePath: "Genvite",
  },
  {
    path: "/dediPro/dedication-items",
    name: "DedicationItems",
    view: "DedicationItems",
    filePath: "DediPro",
  },
  {
    path: "/dediPro/dedication-item/:id",
    name: "DedicationItemView",
    view: "DedicationItemView",
    filePath: "DediPro",
  },
  {
    path: "/dediPro/dedication-sales",
    name: "DedicationSales",
    view: "DedicationSales",
    filePath: "DediPro",
  },
  {
    path: "/dediPro/dedication-sale/:id",
    name: "DedicationSaleView",
    view: "DedicationSaleView",
    filePath: "DediPro",
  },
  {
    path: "/calendar",
    name: "Calendar",
    view: "Calendar",
    filePath: "Calendar",
  },
  // {
  //     path: "/user-profile",
  //     name: "User Profile",
  //     view: "UserProfile"
  // },
  // {
  //     path: "/table-list",
  //     name: "Table List",
  //     view: "TableList"
  // },
  // {
  //     path: "/typography",
  //     view: "Typography"
  // },
  // {
  //     path: "/icons",
  //     view: "Icons"
  // },
  // {
  //     path: "/maps",
  //     view: "Maps"
  // },
  // {
  //     path: "/notifications",
  //     view: "Notifications"
  // },
];
